module.exports = __webpack_public_path__ + "media/images/move-action-icon-b9abb92727545e4080f3cb245d69bb1a.svg";